export default "__VITE_ASSET__DF65nJno__"